import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
    <path d="M0.875977 0.000396729H20.001V2.1254H0.875977V0.000396729Z" fill="currentColor" />
    <path d="M0.875977 7.4379H20.001V9.5629H0.875977V7.4379Z" fill="currentColor" />
    <path d="M0.875977 14.8754H20.001V17.0004H0.875977V14.8754Z" fill="currentColor" />
  </svg>
);
